export function hash(arg = '') {
  const nth = arg.length;
  let result = 0;

  if (nth > 0) {
    let i = -1;
    let chr;

    while (++i < nth) {
      chr = arg.charCodeAt(i);
      result = (result << 5) - result + chr;
      result |= 0;
    }
  }

  return result;
}
